import { render, staticRenderFns } from "./veStuMoralActiveShow.vue?vue&type=template&id=06cd607f&scoped=true"
import script from "./veStuMoralActiveShow.vue?vue&type=script&lang=js"
export * from "./veStuMoralActiveShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cd607f",
  null
  
)

export default component.exports